import { loadLogout } from '@/route-handlers/logout';
import WaitingIndicatorCircle from '@ui/waiting-indicator-circle/waiting-indicator-circle';

export const clientLoader = Object.assign(loadLogout, { hydrate: true });
export { default } from '@/pages/logout';

export function HydrateFallback() {
  return (
    <div className="flex-center padding-40">
      <WaitingIndicatorCircle fill={'primary'} size={40} />
    </div>
  );
}
